__turbopack_context__.v({
  "aboutUs": "about-us-module__MSaI0a__aboutUs",
  "aboutUsInfo": "about-us-module__MSaI0a__aboutUsInfo",
  "aboutUsSwitchingModule": "about-us-module__MSaI0a__aboutUsSwitchingModule",
  "aboutUsSwitchingModuleWrapper": "about-us-module__MSaI0a__aboutUsSwitchingModuleWrapper",
  "aboutUsWrapper": "about-us-module__MSaI0a__aboutUsWrapper",
  "active": "about-us-module__MSaI0a__active",
  "tab": "about-us-module__MSaI0a__tab",
  "tabList": "about-us-module__MSaI0a__tabList",
  "tabPanel": "about-us-module__MSaI0a__tabPanel",
});
